import { getDefaultStore } from "jotai";

import { measureModeAtom } from "../../atoms/measureAtoms";
import { activeSegmentIndexAtom, isSegmentationActiveAtom } from "../../atoms/segmentationAtoms";
import { registerCommand } from "./registry";

registerCommand("exitMeasureMode", () => {
  const store = getDefaultStore();
  store.set(measureModeAtom, null);
  store.set(isSegmentationActiveAtom, false);
  store.set(activeSegmentIndexAtom, 0);
});
